"use strict";

/** @namespace Fotobook.substrate */
(function () {
    var self = Fotobook.substrate = {

        SUBSTRATE_TYPE_BOOKLET: 'booklet',
        SUBSTRATE_TYPE_CUSTOM: 'custom',
        substrateRecalTimer: null,

        /** получить тип подложки */
        getSubstrateType: function () {
            return Fotobook.book.product.is_custom_substrate ? self.SUBSTRATE_TYPE_CUSTOM : self.SUBSTRATE_TYPE_BOOKLET;
        },

        getCoverBonus: function () {
            var displayRegion = Fotobook.displayRegions.getRegion(Fotobook.PageType.PAGE, true);

            return displayRegion ? (displayRegion.height + displayRegion.width) / 2 * 0.02 : 0; // 0.02 для того, чтобы обложка выступала за книгу на 2%
        },

        pageStackSize: function () {
            var displayRegion = Fotobook.displayRegions.getRegion(Fotobook.PageType.PAGE, true);

            return displayRegion ? (displayRegion.height + displayRegion.width) / 2 * 0.02 : 0; // 0.02 для того, чтобы pageStack выступал за книгу на 2%
        },

        recalculate() {
            //  предотвращаем многократный пересчет подложки
            if (self.substrateRecalTimer) {
                clearTimeout(self.substrateRecalTimer);
            }

            self.substrateRecalTimer = setTimeout(() => {
                const substrate = self.getSubstrateType();
                self[substrate].recalculate();
                self[substrate].recalculateWithZoom();
                self.substrateRecalTimer = null;
                Fotobook.safeArea.processSafeAreaButton();
            }, 100);
        },

        recalculateWithZoom() {
            return self[self.getSubstrateType()].recalculateWithZoom();
        },

        resize($book) {
            return self[self.getSubstrateType()].resize($book);
        },

        getPageMargins: function () {
            var $html = $(document.documentElement),
                cover = $html.hasClass("cover"),
                marginWidth = 0,
                marginHeight = 0,
                bookBindType = Fotobook.book.bookbind.type
            ;

            if (!cover) {
                var pageStackSize = self.pageStackSize();
                if (bookBindType === Fotobook.BookbindType.BOOK) {
                    var coverBonus = self.getCoverBonus();
                    // двойная толщина pageStack по сравнению с пружиной. Видимо, так лучше выглядит
                    marginWidth = 2 * pageStackSize + coverBonus;
                    // обложка выступает сверху и снизу
                    marginHeight = 2 * coverBonus;
                } else if (bookBindType === Fotobook.BookbindType.CLIP || bookBindType === Fotobook.BookbindType.SPRING) {
                    marginWidth = pageStackSize;
                    // страницы видны также снизу
                    marginHeight = pageStackSize;
                }
            }

            return {
                "width": marginWidth,
                "height": marginHeight,
            };
        },
    };

    $(document)
        .on(Fotobook.events.CHANGE_PAGE, self.recalculate)
        .on(Fotobook.events.COVER_STYLE_CHANGED, self.recalculate);
})();
